import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ShieldAlert, FileBarChart } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { useMeta } from "@/lib/useMeta";

export default function SharedReport() {
  useMeta({ title: "Shared report | Plan-Sarthi", description: "Open a shared Plan-Sarthi report.", path: "/shared" });
  const { token } = useParams();
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    api
      .get(`/share/${token}`)
      .then(({ data }) => setState({ loading: false, data }))
      .catch((err) => setState({ loading: false, error: apiError(err.response?.data?.detail) }));
  }, [token]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6" data-testid="shared-report-page">
      <div className="w-full max-w-lg border border-border bg-card p-7">
        {state.loading ? (
          <p className="text-sm text-muted-foreground">Validating link…</p>
        ) : state.error ? (
          <div data-testid="shared-access-denied">
            <ShieldAlert className="w-8 h-8 text-red-500" />
            <h1 className="text-xl font-semibold mt-3">{state.error}</h1>
            <Link to="/projects" className="inline-block mt-5">
              <Button variant="outline" size="sm" data-testid="shared-back-btn">Back to my workspace</Button>
            </Link>
          </div>
        ) : (
          <div data-testid="shared-report-content">
            <FileBarChart className="w-8 h-8 text-primary" />
            <h1 className="text-xl font-semibold mt-3">{state.data.link.label}</h1>
            <p className="text-[13px] text-muted-foreground mt-1.5">
              {state.data.project.name}
              {state.data.project.client ? ` · ${state.data.project.client}` : ""}
              {state.data.project.location ? ` · ${state.data.project.location}` : ""}
            </p>
            <p className="text-[12px] text-muted-foreground mt-3">
              Shared by {state.data.link.created_by} · expires {new Date(state.data.link.expires_at).toLocaleString("en-IN")}
            </p>
            <Link to={`/p/${state.data.project.id}/reports`} className="inline-block mt-5">
              <Button size="sm" data-testid="shared-open-report-btn">Open the report</Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
